import React from "react";
import { cn } from "@/lib/utils";

interface SeparatorProps extends React.HTMLAttributes<HTMLHRElement> {
    variant?: "default" | "transparent";
    className?: string;
}

const Separator = React.forwardRef<HTMLHRElement, SeparatorProps>(
    ({ className, variant = "default", ...props }, ref) => {
        return (
            <hr
                ref={ref}
                className={cn(
                    "border w-full",
                    variant === "transparent" ? "border-transparent" : "border-muted",
                    className,
                )}
                {...props}
            />
        );
    },
);
Separator.displayName = "Separator";

export default Separator;
